import { RouteType } from '../types/routes'
import HomePage from '../pages/Home'
import GuestGuard from '../components/GuestGuard'
import AuthGuard from '../components/AuthGuard'
import OnboardingPage from '../pages/Onboarding'
import AccountPage from '../pages/Account'
import InitPasswordPage from '../pages/Password/init'
import ResetPasswordPage from '../pages/Password/reset'
import DeclarationPage from '../pages/Declaration'
import UserDeclarationsPage from '../pages/UserDeclarations'
import ForgotPasswordPage from '../pages/Password/forgot'
import AuthCallback from '../pages/AuthCallback'
import Page from '../pages/Page'
import DeclarationGuard from '../components/DeclarationGuard'

import { routesPath } from './index'

const publicRoutes: RouteType = {
  path: '',
  component: null,
  guard: null,
  children: [
    {
      path: routesPath.onboarding,
      name: 'Login',
      component: OnboardingPage,
      guard: GuestGuard,
    },
    {
      path: routesPath.initPassword,
      name: 'InitPassword',
      component: InitPasswordPage,
      guard: GuestGuard,
    },
    {
      path: routesPath.forgotPassword,
      name: 'ForgotPassword',
      component: ForgotPasswordPage,
      guard: GuestGuard,
    },
    {
      path: routesPath.resetPassword,
      name: 'ResetPassword',
      component: ResetPasswordPage,
    },
    {
      path: routesPath.page,
      name: 'Page',
      component: Page,
    },
    {
      path: routesPath.authCallback,
      name: 'AuthCallback',
      component: AuthCallback,
      guard: GuestGuard,
    },
  ],
}

const privateRoutes: RouteType = {
  path: '',
  component: null,
  guard: AuthGuard,
  children: [
    {
      path: routesPath.home,
      name: 'Home',
      component: HomePage,
      guard: DeclarationGuard,
    },
    {
      path: routesPath.account,
      name: 'Account',
      component: AccountPage,
    },
    {
      path: routesPath.declaration,
      name: 'Declaration',
      component: DeclarationPage,
    },
    {
      path: routesPath.userDeclarations,
      name: 'UserDeclarations',
      component: UserDeclarationsPage,
      guard: DeclarationGuard,
    },
  ],
}

export const defaultLayoutRoutes = [publicRoutes, privateRoutes]
